export const PHOTOBOOKS_MPVID = "photobooks";
export const isPhotobooks = (mpvId: string): boolean => mpvId === PHOTOBOOKS_MPVID;

export const scrollToTabs = () => {
  const element = document.getElementById("product-page-tabs");
  if (element) {
    element.scrollIntoView({ behavior: "smooth" });
  }
};
